<template>
  <div id="main-wrapper">
    <AdminNavbar />

    <div class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <h2 class="ipt-title">{{ t('Welcome!') }}</h2>
          </div>
        </div>
      </div>
    </div>

    <section class="bg-light">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-3 col-md-12">
            <AdminSidebar :open="show" @update:open="show = $event" :user="user" />
          </div>

          <div class="col-lg-9 col-md-12">
            <div class="dashboard-wraper">
              <h6 class="mb-3">
                {{ t('Register Visit') }}
              </h6>

              <div class="row g-3">
                <div
                  v-for="exhibit in exhibits"
                  :key="exhibit.id"
                  class="col-lg-3 col-md-4 col-sm-6"
                >
                  <div
                    class="exhibit-card"
                    @click="openModal(exhibit)"
                  >
                    <img :src="exhibit.logo" alt="exhibit logo" class="exhibit-logo mb-2" />
                    <h6 style="color:#6A715D">{{ exhibit.name }}</h6>
                  </div>
                </div>
              </div>
              <div
                  v-if="qrCode && registeredExhibit"
                  class="qr-section text-center mt-5"
              >
                  <h4 class="mb-3">
                      {{ t("Your QR Code") }}
                  </h4>

                  <div class="mb-3">
                      <strong>
                          {{ t("Exhibition") }}:
                      </strong>

                      <span>
                          {{ registeredExhibit.name }}
                      </span>
                  </div>

                  <div class="qr-card">
                      <img
                        v-if="qrCode"
                        :src="qrCode"
                        alt="QR Code"
                        style="width: 250px; height: 300px;"
                      />

                  </div>

                  <div class="mt-3">
                      <button
                          type="button"
                          class="btn btn-primary"
                          @click="downloadQr"
                      >
                          {{ t("Download") }}
                      </button>
                  </div>
              </div>
              <!-- Modal -->
              <div v-if="modalExhibit" class="modal-overlay" @click.self="closeModal">
                <div class="modal-content">
                  
                  <div class="modal-header">
                    <h5>{{ modalExhibit.name }}</h5>
                    <button class="close-btn" @click="closeModal">&times;</button>
                  </div>
                  
                  <div class="modal-body">
                    <p v-html="modalExhibit?.description || ''" class="description"></p>

                    <p>
                      <strong>{{ $t('Start Date') }}:</strong> {{ modalExhibit?.start_date }}<br>
                      <strong>{{ $t('End Date') }}:</strong> {{ modalExhibit?.end_date }}
                    </p>

                    <p><strong>{{ $t('Number of Halls') }}:</strong> {{ modalExhibit?.halls_count }}</p>
                    <ul v-if="modalExhibit?.halls?.length" class="hall-list">
                      <li v-for="hall in modalExhibit.halls" :key="hall.id">
                        <strong>{{ hall.name }}:</strong> {{ $t('Number of Stands') }}: {{ hall.stands_count }}
                      </li>
                    </ul>

                    <p>
                      <i class="fa-solid fa-location-dot px-2"></i>
                      {{ modalExhibit.location }}
                    </p>

                    <div class="interests-section mt-4">
                    <h6 class="mb-3">
                      {{ t('Interests') }}
                    </h6>

                    <div
                      v-if="modalExhibit?.interests?.length"
                      class="interests-list"
                    >
                      <label
                        v-for="interest in modalExhibit.interests"
                        :key="interest.id"
                        class="interest-item"
                      >
                        <input
                          type="checkbox"
                          :value="interest.id"
                          v-model="selectedInterestIds"
                        >

                        <span>
                          {{ interest.name }}
                        </span>
                      </label>
                    </div>

                    <div v-else class="text-muted">
                      {{ t('No interests available for this exhibit.') }}
                    </div>
                  </div>
                  </div>
                  
                  <div class="modal-actions">
                    <button class="btn btn-secondary" @click="closeModal">{{ t('Close') }}</button>
                    <button class="btn btn-primary" @click="submitExhibits">{{ t('Submit') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>

    <FooterTop :bg="'theme-bg'" />
    <FooterDark />
    <ScrollToTop />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useToast } from 'vue-toastification'

import AdminSidebar from '@/components/admin-sidebar.vue'
import AdminNavbar from '@/components/navbar/admin-navbar.vue'
import FooterTop from '@/components/footer/footer-top.vue'
import FooterDark from '@/components/footer/footer-dark.vue'
import ScrollToTop from '@/components/scroll-to-top.vue'

const { t, locale } = useI18n()
const toast = useToast()
const router = useRouter()

const show = ref(false)
const user = ref(null)
const exhibits = ref([])
const modalExhibit = ref(null)

const selectedInterestIds = ref([])
const token = localStorage.getItem('auth_token')
const qrCode = ref(null);
const registeredExhibit = ref(null)
onMounted(async () => {
  if (!token) {
    toast.error(t('You are not logged in.'))
    router.replace('/404')
    return
  }

  try {
    const exhibitsResponse = await axios.get('/attendees/exhibits', {
      params: { lang: locale.value },
      headers: { Authorization: `Bearer ${token}` }
    })
    exhibits.value = exhibitsResponse.data.data
  } catch (error) {
    toast.error(t('Failed to load data'))
    router.replace('/404')
  }
})
const openModal = (exhibit) => {
  modalExhibit.value = exhibit

  selectedInterestIds.value = []
}
const closeModal = () => { 
  modalExhibit.value = null 
  selectedInterestIds.value = []
}
const submitExhibits = async () => {
  if (!modalExhibit.value) {
    toast.error(t("Please select an exhibit"))
    return
  }

  try {
    const response =await axios.post(
        "/attendees",
        {
          exhibit_id: modalExhibit.value.id,
          interest_ids: selectedInterestIds.value,
        },
        {
          params: { lang: locale.value },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
    if (response.data.success) {
      qrCode.value = response.data.qr;
      registeredExhibit.value = { ...modalExhibit.value }
      toast.success(t("Attendance registered successfully."))
      closeModal()
    }

  }catch (error) {
    if (error.response?.status === 422) {

      if (error.response.data.errors) {
        Object.values(error.response.data.errors).forEach(messages => {
          toast.error(messages[0]);
        });
      }
      else if (error.response.data.message) {
        toast.error(error.response.data.message);
      }
      return;
    }

    toast.error(
      error.response?.data?.message || t("Failed to save exhibits")
    );

    console.error(error);
  }
}

const downloadQr = () => {
    if (!qrCode.value) return;

    const link = document.createElement('a');

    link.href = qrCode.value;
    link.download = 'attendee-qr.png';

    document.body.appendChild(link);
    link.click();
    link.remove();
};
</script>

<style scoped>
.exhibit-card {
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #fff;
}
.exhibit-card.selected {
  background-color: #C48B6E;
  color: #fff;
}
.exhibit-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}
.exhibit-logo {
  width: 60px;
  height: 60px;
  object-fit: contain;
  border-radius: 8px;
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s;
}
.modal-content {
  background-color: #fff;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  padding: 1.5rem;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  animation: slideIn 0.3s;
  overflow-y: auto;
  max-height: 90vh;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}
.modal-body {
  line-height: 1.5;
  color: #333;
}
.hall-list {
  padding-left: 1rem;
  margin: 0.5rem 0;
  list-style-type: disc;
}
.notification-settings label {
  display: block;
  margin-bottom: 0.5rem;
}
.notification-settings input {
  width: 100%;
  padding: 0.3rem 0.5rem;
  margin-top: 0.2rem;
  border-radius: 6px;
  border: 1px solid #ccc;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
}
@keyframes fadeIn { from {opacity:0;} to {opacity:1;} }
@keyframes slideIn { from {transform: translateY(-20px);} to {transform: translateY(0);} }

.interests-section {
  border-top: 1px solid #eee;
  padding-top: 1rem;
}

.interests-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.interest-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.interest-item:hover {
  background-color: #f8f9fa;
}

.interest-item input {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.interest-item span {
  cursor: pointer;
}

.qr-result {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.qr-card {
    background: #fff;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
}

.qr-image {
    width: 250px;
    height: 250px;
    object-fit: contain;
    display: block;
}
</style>
